import { DashboardApi } from "../../../../services/Api/Organization/types";

export enum DashboardFetchActions {
	FETCH_PRODUCT_REPORTS = "FETCH_PRODUCT_REPORTS",
	FETCH_CATEGORY_REPORTS = "FETCH_CATEGORY_REPORTS",
	FETCH_All_DATA = "FETCH_All_DATA",
	FETCH_SALES_REPORTS = "FETCH_SALES_REPORTS",
	FETCH_PAYMENT_REPORTS = "FETCH_PAYMENT_REPORTS",
	FETCH_SALES_ADVANCED_REPORTS = "FETCH_SALES_ADVANCED_REPORTS",
}

export const dashboardDataReducer = (
	state: DashboardApi | undefined,
	action: Record<string, any>
): DashboardApi | undefined => {
	switch (action.type) {
		case DashboardFetchActions.FETCH_All_DATA:
			return action.payload.shouldOverrideExistingData
				? undefined
				: {
						...state,
						...action.payload.data,
				  };
		case DashboardFetchActions.FETCH_PRODUCT_REPORTS:
			return {
				...state,
				product_reports: action.data,
			};
		case DashboardFetchActions.FETCH_CATEGORY_REPORTS:
			return {
				...state,
				category_reports: action.data,
			};
		case DashboardFetchActions.FETCH_SALES_REPORTS:
			return {
				...state,
				sales_reports: action.data,
			};
		case DashboardFetchActions.FETCH_PAYMENT_REPORTS:
			return {
				...state,
				payment_reports: action.data,
			};
		case DashboardFetchActions.FETCH_SALES_ADVANCED_REPORTS:
			return {
				...state,
				sales_advanced_reports: action.data,
			};
		default:
			return state;
	}
};
